<template>
    <v-dialog v-model="openModal" max-width="500px">
        <v-card>
            <div class="modal-header">
                <h4 class="modal-headline">{{ $page.props.lang.addPayment || "Add payment" }}</h4>
                <div class="tools">
                    <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
                </div>
            </div>
            <v-card-text>
                <v-container>
                    <div class="fields">
                        <div class="grid">
                            <label class="custom-label">{{ $page.props.lang.related_membership || 'Related membership fee' }}</label>
                            <v-select
                                v-model="payment.period_id"
                                :items="this.periods"
                                menu-props="auto"
                                item-text="title"
                                item-value="id"
                                @change="updateAmount"
                                :error-messages="responseErrors.period_id"
                                @focus="responseErrors.period_id=''"
                                outlined
                                :disabled="period_id != null"
                                dense
                            ></v-select>
                            
                            <p class="custom-label">{{ $page.props.lang.amount || 'Amount' }}</p>
                            <v-text-field v-model="payment.amount"
                                :suffix="$page.props.organization.settings.currency"
                                outlined dense
                                :error-messages="responseErrors.amount" @focus="responseErrors.amount=''"></v-text-field>
                        
                            <p class="custom-label">{{ $page.props.lang.payment_date || "Payment date" }}</p>
                            <v-menu
                                v-model="startDatePicker"
                                :close-on-content-click="false"
                                :return-value.sync="today" 
                                transition="scale-transition"
                                offset-y 
                                min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field 
                                    :value="payment.transaction_date | formatDate" :hide-details="!responseErrors.transaction_date"
                                    append-icon="mdi-menu-down" readonly v-bind="attrs" v-on="on" @click:append="startDatePicker = true"  
                                    :error-messages="responseErrors.transaction_date" @focus="responseErrors.transaction_date=''"
                                    outlined dense solo flat>
                                </v-text-field>
                            </template>
                            <v-date-picker 
                                        v-model="payment.transaction_date" 
                                        :first-day-of-week="1" no-title scrollable color="primary">
                                            <v-spacer></v-spacer>
                                            <v-btn color="regular" @click="startDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                                            <v-btn color="primary" @click="startDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                                        </v-date-picker>
                                    </v-menu>

                                <p class="custom-label" style="margin-top:25px">{{ $page.props.lang.payment_method||'Payment method'}}</p>     
                                    <v-select style="margin-bottom:25px" v-model="payment.payment_type_id" 
                                    :items="payment_types" item-text="name" item-value="id" outlined dense
                                    :hide-details="!responseErrors.payment_type_id"
                                    :error-messages="responseErrors.payment_type_id" @focus="responseErrors.payment_type_id=''"></v-select> 

                                <p class="custom-label">{{ $page.props.lang.description || 'Description' }}</p>
                                <v-textarea v-model="payment.description"
                                outlined dense hide-details rows="2"></v-textarea>
                            </div>
                        </div>
                        <v-card-actions>
                            <v-checkbox  v-if="$page.props.organization.settings.fiscalization" v-model="payment.fiscalization" label="Fiskalizuj uplatu"></v-checkbox>
                            <v-spacer></v-spacer>
                            <v-btn color="regular" @click="$emit('close')">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn color="primary" @click="savePayment" :loading="savingPayment">{{ $page.props.lang.save || "Save" }}</v-btn>
                        </v-card-actions>
                    </v-container>
                    <v-overlay :value="payModalLoading" :absolute="true" :light="true">
                        <v-progress-circular color="#8b1f62" indeterminate size="64"></v-progress-circular>
                        </v-overlay>
                </v-card-text>
            </v-card>
            <ConfirmModal 
            :open="confirmAmountModal"
            @close="confirmAmountModal = false"
            :title="$page.props.lang.confirmModalTitle || 'Confirmation'" 
            :description="$page.props.lang.confirm_payment_amount || 'Amount is greater than original price, are You sure yoo want to continue?'" 
            @no="confirmAmountModal = false" 
            @yes="forceSavePayment()"
            >
            </ConfirmModal>
        </v-dialog>
</template>

<script>
import EventBus from '@/js/eventbus'
import VueTimepicker from 'vue2-timepicker'
import ConfirmModal from '@/js/Components/ConfirmModal'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
    name: "PaymentModal",

     components: {
        VueTimepicker,
        ConfirmModal
    },
    props: {
        modal: Boolean,
        member_id: Number,
        lang: Object,
        payment_types: Array,
        period_id: Number
    },
    data() {
        return {
            periods:[],
            payment:{
                member_id: this.member_id,
                period_id: this.period_id,
                amount: null,
                description: null,
                payment_type_id: 1,
                fiscalization: this.$page.props.organization.settings.fiscalization,
                transaction_date:moment().format('YYYY-MM-DD'),
                force_payment: false
            },
            today : moment().format('YYYY-MM-DD'),
            startDatePicker: false,
            responseErrors:[],
            savingPayment: false,
            payModalLoading:false,
            confirmAmountModal: false,
        }
    },
    computed: {
        openModal: {
            get: function() {
                return this.modal
            },
            set: function() {
                this.$emit('close')
                return false
            }
        },
    },

    created(){

        this.payModalLoading = true;
        axios.get('/backoffice/members/getPeriods?id='+this.member_id)
                .then(response => {
                    this.payModalLoading = false;
                    this.periods = response.data.periods;
                    this.getAmount();
                })
                .catch(error => {
                    this.payModalLoading = false;
                });
    },

    methods: {
        getAmount(){
            if(this.period_id != null){
                 var c = this.periods.find(x => x.id == this.period_id);
                 return this.payment.amount = c.due;
            }else{
                return this.payment.amount;
            }
           
        },
        updateAmount(e){
           var c = this.periods.find(x => x.id == e);
           if(c){
               this.payment.amount = c.due;
           }
        },

        forceSavePayment(){
            this.payment.force_payment = true;
            this.savePayment();
        },

        printFiscal(data){

        axios.post('http://localhost:8085/stampatifiskalniracun', data)
        .then((response) => {
            this.provessFiscalResponse(response.data);
        }).catch((error) => {
            EventBus.$emit('CLOSE_PAYMENT_MODAL', {});
            EventBus.$emit('SHOW_NOTIFICATION',{
                            message: "Spajanje na fiskalni server nije uspjelo, uplata je zabeležena uspješno. Molimo Vas da fisklani račun izradite na fiskalnoj kasi.",
                            color: 'error',
                            timeout: 10000
                        })
        })
      },

      provessFiscalResponse(response){

        axios.post('/backoffice/processxml', {xml: response}).
        then((response) => {
            var color = "error";
            if(response.data.status==="OK"){
                color = "success";       
            }

            EventBus.$emit('CLOSE_PAYMENT_MODAL', response.data);
            EventBus.$emit('SHOW_NOTIFICATION', {
                            message: response.data.message,
                            color: color,
                            timeout: 5000
                        });
            
        })
        .catch(error => {
           
                    this.savingPayment = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                });
      },
        savePayment() {
 
            this.savingPayment = true;
            axios.post('/backoffice/members/addPayment', this.payment)
                .then(response => {
                    this.savingPayment = false;

                    if(response.data.status==="CONFIRMATION" ){
                        if (confirm(response.data.message)) {
                            this.payment.force_payment = true;
                             this.savePayment();
                             return;
                        } 
                    }
                    
                    if(response.data.status==="OK" && response.data.data != null) {
                        this.printFiscal(response.data.data);
                    }else if(response.data.status==="OK" && response.data.data == null){ 
                        
                        EventBus.$emit('CLOSE_PAYMENT_MODAL', response.data);
                        color = "success";
                      
                        EventBus.$emit('SHOW_NOTIFICATION', {
                            message: response.data.message,
                            color: color,
                            timeout: 5000
                        });
                    }
                })
                .catch(error => {
                   
                    this.savingPayment = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                });
        },
    }
}
</script>
